import { createStagesSlice } from "./shared/createStagesSlice";

export const proposalStagesSlice = createStagesSlice({
  name: "proposalStages",
  hasDelete: true,
});

export const {
  setProposalStages,
  setEditableProposalStages,
  addStage,
  updateStage,
  removeStage,
  reorderStages,
  setIsEditing,
  setIsDirty,
  setIsLoading,
  setIsLocked,
  setLockedBy,
  setSelectedIndex,
  setGateMode,
  setEditableGateMode,
  setStageQuestions,
  addStageQuestion,
  removeStageQuestion,
  reorderStageQuestions,
} = proposalStagesSlice.actions;

export default proposalStagesSlice.reducer;
